// src/pages/settings/ClientFilterChips.tsx — barre de chips "filtrer par client" (+ compteur),
// partagée par SitesTab et MetersTab (blocs quasi identiques avant factorisation). N'affiche rien
// si moins de 2 clients (pas de filtre utile dans ce cas).

import type { ClientRecord } from "../../api/settingsApi";

export function ClientFilterChips({ clients, active, onChange, count, style }: {
  clients: ClientRecord[];
  active: string;   // "" = tous
  onChange: (clientId: string) => void;
  /** Nombre d'éléments pour un client donné ; count("") = total tous clients confondus. */
  count: (clientId: string) => number;
  style?: React.CSSProperties;
}) {
  if (clients.length <= 1) return null;
  return (
    <div style={{display:"flex",alignItems:"center",gap:6,flexWrap:"wrap",...style}}>
      <span style={{fontSize:11,color:"var(--text-faint)",fontFamily:"var(--ff-title)",
        fontWeight:700,letterSpacing:0.5,textTransform:"uppercase",flexShrink:0}}>
        Client
      </span>
      {[{id:"",name:"Tous"},...clients].map(c => {
        const isActive = active === c.id;
        return (
          <button key={c.id} onClick={() => onChange(c.id)}
            style={{
              fontSize:11, padding:"3px 10px", borderRadius:20,
              border: isActive ? "1.5px solid var(--green-dim)" : "1.5px solid #ddd",
              background: isActive ? "var(--green-dim)" : "transparent",
              color:      isActive ? "#fff"               : "var(--text-muted)",
              cursor:"pointer", fontFamily:"var(--ff-title)", fontWeight:isActive?700:500,
              transition:"all 0.15s",
            }}>
            {c.name} ({count(c.id)})
          </button>
        );
      })}
    </div>
  );
}
